import { Roles } from 'model';
import { useCurrentUser } from './useCurrentUser';

export const useUserRoles = (): Roles[] => {
	const user = useCurrentUser();
	return user.roles;
};
